import { render, staticRenderFns } from "./auditPwd.vue?vue&type=template&id=5920060a&scoped=true"
import script from "./auditPwd.vue?vue&type=script&lang=js"
export * from "./auditPwd.vue?vue&type=script&lang=js"
import style0 from "./auditPwd.vue?vue&type=style&index=0&id=5920060a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920060a",
  null
  
)

export default component.exports